<template>
  <div @keyup.enter='$emit("ready")'>
    <h2>Datos de la entidad</h2>
    <p>Complete por favor los datos de su entidad.</p>
    <div class="wizard-form">
      <vs-input name="cuit"
                data-test="input-cuit"
                v-validate="'required|length:13|validateOnDB:organization,cuit'"
                :danger="this.errors.has('cuit')"
                :danger-text="this.errors.first('cuit')"
                v-mask="'##-########-#'"
                size="large"
                label-placeholder="CUIT"
                v-model="cuit">
      </vs-input>
      <vs-input name="razon-social"
                data-test="input-razonsocial"
                v-validate="'required|validateOnDB:organization,business_name'"
                :danger="this.errors.has('razon-social')"
                :danger-text="this.errors.first('razon-social')"
                size="large"
                label-placeholder="Razón Social"
                v-model="businessName">
      </vs-input>
      <div class="input-group">
        <select name="state"
                data-test="provincia-opt"
                v-validate="'required'"
                :danger="this.errors.has('state')"
                size="large"
                @change="getCities($event.target.value)"
                :class="{changed: !!(this.state)}"
                v-model="state">
          <option value="" disabled>Provincia</option>
          <option :key="index" :value="state.name" :text="state.name" v-for="(state,index) in states">{{ state.name }}</option>
        </select>
        <label  for="state">Provincia</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('state') }}</span>
        </div>
      </div>
      <div class="input-group">
        <select name="city"
                data-test="input-city"
                v-validate="'required'"
                :danger="this.errors.has('city')"
                size="large"
                :class="{changed: !!(this.city)}"
                v-model="city">
          <option data-test="ciudad-opt" value="" disabled>Ciudad</option>
          <option :key="index" :value="city.name" :text="city.name" v-for="(city,index) in cities">{{ city.name }}</option>
        </select>
        <label data-test="ciudad-opt" for="state">Localidad</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('city') }}</span>
        </div>
      </div>
      <vs-input name="cp"
                data-test="input-codep"
                v-validate="'required|alpha_dash'"
                :danger="this.errors.has('cp')"
                :danger-text="this.errors.first('cp')"
                size="large"
                label-placeholder="CP"
                v-model="zipcode">
      </vs-input>
      <vs-input name="address"
                data-test="input-adress"
                v-validate="'required'"
                :danger="this.errors.has('address')"
                :danger-text="this.errors.first('address')"
                size="large"
                label-placeholder="Dirección Comercial"
                v-model="commercialAddress">
      </vs-input>
      <vs-input name="email"
                data-test="input-email"
                v-validate="'required|email|validateOnDB:organization,email'"
                :danger="this.errors.has('email')"
                :danger-text="this.errors.first('email')"
                type='email'
                size="large"
                label-placeholder="Correo electrónico institucional"
                v-model="email">
      </vs-input>
      <vs-input name="phone"
                data-test="input-phone"
                v-validate="'required'"
                :danger="this.errors.has('phone')"
                :danger-text="this.errors.first('phone')"
                v-mask="'###-#######'"
                size="large"
                label-placeholder="Teléfono institucional"
                v-model="phone">
      </vs-input>

      <vs-input name="mothers-for-production"
                v-if="market.sell"
                v-validate="'numeric'"
                type="number"
                :danger="this.errors.has('mothers-for-production')"
                :danger-text="this.errors.first('mothers-for-production')"
                size="large"
                label-placeholder="Cantidad de Madres de Producción"
                v-model.number="productionMothers">
      </vs-input>
      <vs-input name="slaughterQuantity"
                v-if="market.sell"
                v-validate="'numeric'"
                :danger="this.errors.has('slaughterQuantity')"
                :danger-text="this.errors.first('slaughterQuantity')"
                size="large"
                label-placeholder="Cantidad de animales enviados a faena por mes"
                v-model.number="slaughterQuantityPerMonth">
      </vs-input>
      <vs-input name="ruca"
                v-if="market.buy"
                v-validate="'required'"
                v-mask="'#####'"
                :danger="this.errors.has('ruca')"
                :danger-text="this.errors.first('ruca')"
                size="large"
                label-placeholder="Matrícula RUCA"
                v-model="ruca">
      </vs-input>

      <div class="input-group">
        <select name="income_tax_situation_list"
                data-test="input-taxsituation"
                :danger="this.errors.has('income_tax_situation_list')"
                v-validate="'required'"
                v-model="incomeTaxSituation"
                :class="{changed: !!(incomeTaxSituation)}">
          <option :key="index" :value="item.value" :text="item.text" v-for="(item,index) in income_tax_situation_list">{{ item.text }}</option>
        </select>
        <label for="income_tax_situation_list">Situación frente al impuesto a las ganancias</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('income_tax_situation_list') }}</span>
        </div>
      </div>
      <div class="input-group">
        <select name="iva_situation_list"
                data-test="ivasituation-opt"
                v-validate="'required'"
                :danger="this.errors.has('iva_situation_list')"
                v-model="ivaSituation"
                :class="{changed: !!(ivaSituation)}">
          <option :key="index" :value="item.value" :text="item.text" v-for="(item,index) in iva_situation_list">{{ item.text }}</option>
        </select>
        <label for="iva_situation_list">Situación frente al IVA</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('iva_situation_list') }}</span>
        </div>
      </div>
      <div class="input-group">
        <we-file-uploader @file-change="updateLogo" @throwError="throwError" :accepted-extensions="'image/png, image/jpg, image/jpeg'"/>
        <div v-if="error" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ error }}</span>
        </div>
      </div>

      <vs-input name="notification-email"
                :danger="this.errors.has('notification-email')"
                :danger-text="this.errors.first('notification-email')"
                size="large"
                v-validate="'email'"
                label-placeholder="Email de notificaciones"
                v-model="notificationEmails">
      </vs-input>

      <div class="input-group">
        <textarea data-test="comments" name="comments" placeholder="Comentarios (opcional)" v-model="comments" :class="{changed: !!(comments)}" rows="5"/>
        <label for="comments">Comentarios (opcional)</label>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'
import { Validator } from 'vee-validate'

const fetchCountries = gql`
  query fetchCountries {
    fetchCountries {
      name
      id
    }
  }
`

const fetchStates = gql`
  query fetchStates($countryId: Int!) {
    fetchStates(countryId: $countryId) {
      name
      id
    }
  }
`

const fetchCities = gql`
  query fetchCities($stateId: Int!) {
    fetchCities(stateId: $stateId) {
      name
    }
  }
`

export default {
  name: 'signup-organization-data',
  methods: {
    ...mapMutations('SignUp', [
      'setLogo'
    ]),
    throwError() {
      this.error = 'Formato de imagen invalido'
    },
    updateLogo (value) {
      this.error = ''
      this.setLogo(value.file)
    },
    formWithoutErrors () {
      return this.$validator.validate()
    },
    getCountries () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCountries)
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.state = ''
          this.city = ''
          this.countries = res.data.data.fetchCountries
          this.getStates('Argentina')
        }
      })
    },
    getStates (countryName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchStates),
        variables: {
          countryId: this.getLocalizationId('countries', countryName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.city = ''
          this.states = res.data.data.fetchStates
        }
      })
    },
    getCities (stateName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCities),
        variables: {
          stateId: this.getLocalizationId('states', stateName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.cities = res.data.data.fetchCities
        }
      })
    },
    getLocalizationId (arrayName, name) {
      return this[arrayName].find(q => q.name === name).id
    }
  },
  beforeMount () {
    this.getCountries()
  },
  computed: {
    ...mapState({
      market: state => state.SignUp.market
    }),
    cuit: {
      get () {
        return this.$store.state.SignUp.organization.cuit
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'cuit', data: 'organization', value: val })
      }
    },
    country: {
      get () {
        return this.$store.state.SignUp.organization.country
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'country', data: 'organization', value: val })
      }
    },
    state: {
      get () {
        return this.$store.state.SignUp.organization.state
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'state', data: 'organization', value: val })
      }
    },
    businessName: {
      get () {
        return this.$store.state.SignUp.organization.businessName
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'businessName', data: 'organization', value: val })
      }
    },
    city: {
      get () {
        return this.$store.state.SignUp.organization.city
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'city', data: 'organization', value: val })
      }
    },
    incomeTaxSituation: {
      get () {
        return this.$store.state.SignUp.organization.incomeTaxSituation
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'incomeTaxSituation', data: 'organization', value: val })
      }
    },
    iibbSituation: {
      get () {
        return this.$store.state.SignUp.organization.iibbSituation
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'iibbSituation', data: 'organization', value: val })
      }
    },
    ivaSituation: {
      get () {
        return this.$store.state.SignUp.organization.ivaSituation
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'ivaSituation', data: 'organization', value: val })
      }
    },
    comments: {
      get () {
        return this.$store.state.SignUp.organization.comments
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'comments', data: 'organization', value: val })
      }
    },
    zipcode: {
      get () {
        return this.$store.state.SignUp.organization.zipcode
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'zipcode', data: 'organization', value: val })
      }
    },
    email: {
      get () {
        return this.$store.state.SignUp.organization.email
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'email', data: 'organization', value: val })
      }
    },
    commercialAddress: {
      get () {
        return this.$store.state.SignUp.organization.commercialAddress
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'commercialAddress', data: 'organization', value: val })
      }
    },
    phone: {
      get () {
        return this.$store.state.SignUp.organization.phone
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'phone', data: 'organization', value: val })
      }
    },
    logo: {
      get () {
        return this.$store.state.SignUp.organization.logo
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'logo', data: 'organization', value: val })
      }
    },
    productionMothers: {
      get () {
        return this.$store.state.SignUp.organization.productionMothers
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'productionMothers', data: 'organization', value: val })
      }
    },
    ruca: {
      get () {
        return this.$store.state.SignUp.organization.ruca
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'ruca', data: 'organization', value: val })
      }
    },
    slaughterQuantityPerMonth: {
      get () {
        return this.$store.state.SignUp.organization.slaughterQuantityPerMonth
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'slaughterQuantityPerMonth', data: 'organization', value: val })
      }
    },
    notificationEmails: {
      get () {
        return this.$store.state.SignUp.organization.notificationEmails
      },
      set (val) {
        this.$store.commit('SignUp/updateProperty', { prop: 'notificationEmails', data: 'organization', value: val })
      }
    }
  },
  data: function () {
    return {
      countries: [],
      error: '',
      states: [],
      cities: [],
      income_tax_situation_list: [
        { text: 'Situación frente al impuesto a las Ganancias', value: '' },
        { text: 'Inscripto', value: 'Inscripto' },
        { text: 'No Inscripto', value: 'No inscripto' },
        { text: 'Exento', value: 'Exento' },
        { text: 'Monotributista', value: 'Monotributista' }
      ],
      iibb_situation_list: [
        { text: 'Situación frente a los IIBB', value: '' },
        { text: 'Inscripto Convenio', value: 'Inscripto convenio' },
        { text: 'Inscripto Local', value: 'Inscript local' },
        { text: 'No inscripto', value: 'No inscripto' },
        { text: 'Exento', value: 'Exento' }
      ],
      iva_situation_list: [
        { text: 'Situación frente al IVA', value: '' },
        { text: 'Inscripto', value: 'Inscripto' },
        { text: 'Consumidor Final', value: 'Consumidor final' },
        { text: 'Exento', value: 'Exento' },
        { text: 'Monotributista', value: 'Monotributista' }
      ]
    }
  }
}
</script>
